'use client';
import styled from 'styled-components';

export const StyledComparisonChart = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.get(props.background)};
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: ${props => props.theme.spacing(4)};
  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(10, 20)};
  }
`;

export const Subheader = styled.p`
  ${props => props.theme.typography.heading5};
  ${props => props.theme.fontFamily.base};
  text-align: center;
`;

export const ScrollWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: fit-content;
  max-width: 100%;
  min-width: 0;
  align-items: flex-start;
  margin: ${props => props.theme.spacing(6, 0)};
  position: relative;
  overscroll-behavior-x: none;
  padding: ${props => props.theme.spacing(2, 2, 2, 2)};
  background-color: ${props => props.theme.colors.background.base};
  border-radius: ${props => props.theme.spacing(10)};
  overflow: hidden;

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(10, 20, 10, 20)};
    width: ${props => (props.items > 3 ? 'fit-content' : '90%')};
    max-width: ${props => (props.items > 3 ? '100%' : '1200px')};
  }
`;

export const ChartRowHeaders = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.background.base};
  flex-shrink: 0;
  z-index: 2;
  flex-direction: column;
  width: 33.333%;
  border-radius: ${props => props.theme.spacing(10, 0, 0, 10)};
  @media ${props => props.theme.laptop} {
    width: ${props => (props.items > 3 ? '300px' : '33.333%')};
  }
`;

export const ScrollContainer = styled.div`
  flex: 1;
  overflow-x: scroll;
  overscroll-behavior-x: none;
  min-width: 0;
  color: ${props => props.theme.colors.text.secondary};
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  border-radius: ${props => props.theme.spacing(0, 10, 10, 0)};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  min-width: 100%;
`;

export const ColumnsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-shrink: 0;
  z-index: 1;
  background-color: ${props => props.theme.colors.background.base};
`;

export const StickyColumn = styled.div`
  display: flex;
  z-index: 1;
  flex: ${props => (props.items > 3 ? '0.5' : '1')};
  @media ${props => props.theme.laptop} {
    flex: ${props => (props.items > 3 ? '0.25' : '1')};
  }
`;

export const ScrollableColumns = styled.div`
  display: flex;
  flex: 1;
`;

export const ChartColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${({ highlighted, theme }) =>
    highlighted ? theme.colors.hero.plum : theme.colors.background.base};
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  border-radius: ${props => props.theme.spacing(4)};
  z-index: ${props => (props.highlighted ? '1' : '0')};
  @media ${props => props.theme.mobileM} {
    width: ${props =>
      props.highlighted ? '100px' : props.items > 3 ? '80px' : '100px'};
    flex: unset;
  }
  @media ${props => props.theme.mobileL} {
    width: ${props =>
      props.highlighted ? '130px' : props.items > 3 ? '100px' : '120px'};
    flex: 1;
  }
  @media ${props => props.theme.tablet} {
    width: 150px;
    flex: 1;
  }
`;

export const ComparisonColumnItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  color: ${props => props.theme.colors.text.primary};
  align-items: center;
  min-height: 80px;
  height: 130px;
  border-top: solid 1px #d5d4d4;
  &:first-child {
    border-top: none;
    height: 90px;
  }
  @media ${props => props.theme.laptop} {
    height: 100px;
  }
`;

export const ColumnHeader = styled.p`
  ${props => props.theme.typography.body}
  padding: ${props => props.theme.spacing(1)};
`;

export const StyledComparisonChartItem = styled.div`
  display: flex;
  text-align: center;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  min-height: 80px;
  height: 130px;
  padding: ${props => props.theme.spacing(2, 0, 2, 2)};
  overflow: hidden;
  &:nth-child(n + 2) {
    border-top: solid 1px #d5d4d4;
  }
  &:first-child {
    height: 90px;
  }
  @media ${props => props.theme.laptop} {
    height: 100px;
  }
`;

export const ChartItemHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
  padding-right: ${props => props.theme.spacing(1)};
  text-align: left;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing(1)};
`;

export const Header = styled.h5`
  ${props => props.theme.typography.heading5}
`;

export const Paragraph = styled.p`
  ${props => props.theme.typography.body}
`;
